import { createTheme } from '@mui/material/styles';

/** Site-wide brand colors — use these instead of one-off hex values. */
export const brandColors = {
    headerLavender: 'rgba(128, 121, 154, 0.48)',
    /** Solid lavender for outlines and accent text */
    lavender: 'rgb(128, 121, 154)',
    lavenderDark: 'rgb(98, 92, 118)',
    pageBackground: 'rgba(158, 151, 162, 0.48)',
    footerBlue: '#1976d2',
};

const theme = createTheme({
    palette: {
        primary: {
            main: brandColors.footerBlue,
        },
        background: {
            default: brandColors.pageBackground,
            paper: '#ffffff',
        },
    },
    typography: {
        fontFamily: 'Arial',
        h1: {
            fontWeight: 400,
        },
        body1: {
            fontWeight: 400,
        },
    },
});

export default theme;
